// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ScrollView_wrap__xyQZH"};